
import React, {useEffect, useRef, useState} from "react";
import {ModalWrapper, Reoverlay} from "reoverlay";
import 'reoverlay/lib/ModalWrapper.css';
import Button from "../Button";
import {VscError} from "react-icons/vsc";


const ErrorModal=(props)=>{
    const modalRef = useRef(null);
    useEffect(() => {
        const modalElement = modalRef.current;
        const focusableElements = modalElement.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        const handleTabKeyPress = (event) => {
            if (event.key === "Tab") {
                if (event.shiftKey && document.activeElement === firstElement) {
                    event.preventDefault();
                    lastElement.focus();
                } else if (
                    !event.shiftKey &&
                    document.activeElement === lastElement
                ) {
                    event.preventDefault();
                    firstElement.focus();
                }
            }
        };
        modalElement.addEventListener("keydown", handleTabKeyPress);
        return () => {
            modalElement.removeEventListener("keydown", handleTabKeyPress);

        };
    }, []);
    return <ModalWrapper  onClose={()=>{}}  animation="slideDown" contentContainerClassName="w-11/12 flex flex-col justify-center items-center flex-col md:8/12 lg:w-4/12 2xl:w-3/12 p-5 rounded-xl">
        <VscError className="text-5xl text-red-500 mb-5"/>
        <h1 className="text-2xl  font-bold text-red-500 text-center ">{props.title}</h1>
        <p className="text-gray-700 text-center mb-3 ">{props.message}</p>
        <div ref={modalRef} className={`w-full mt-2 grid gap-2  grid-cols-${(props.showConfirmButton && props.showCancelButton) ? 2:1}`}>

            {props.showConfirmButton && <Button onClick={props.onConfirm} rounded="rounded-lg" theme={props.confirmButtonTheme || "light"} className="text-sm">{props?.confirmButtonText||'باشه'}</Button> }
            {props.showCancelButton && <Button onClick={()=>{
                props.onCancel();
                Reoverlay.hideModal();
            }}  rounded="rounded-lg" theme={props.cancelButtonTheme || "red"} className="text-sm">{props?.cancelButtonText||'بستن'}</Button> }
        </div>

    </ModalWrapper>
}
export default ErrorModal;